import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import MessageBlastContent from "./MessageBlastContent";
import LoadingInComponent from "../../Components/LoadingInComponent";
import Button from "../../Components/Button";
import { useToast } from "../../Components/Toast";
import { GET_REPLACED_MESSAGE_CONTENT_API } from "../../Constant/api";
import PreviewFrame from "../../Components/PreviewFrame";

const MessageBlastPreview = () => {
  const [loading, setLoading] = useState(false);
  const [messageContent, setMessageContent] = useState("");
  const [error, setError] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { toast } = useToast();

  const { state } = location;

  const fetchMessageContent = useCallback(async () => {
    if (!state?.data) return;

    setLoading(true);
    try {
      const response = await axios.get(GET_REPLACED_MESSAGE_CONTENT_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: {
          eventId: sessionStorage.getItem("event_id"),
          templateId: state.recordId,
          formContent: state.data.content,
        },
      });
      setMessageContent(response.data.data.content);
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast("Failed to fetch message content", "error");
      setError(error.response?.data?.message || "Error fetching content");
    } finally {
      setLoading(false);
    }
  }, [state?.data, state.recordId, toast]);

  useEffect(() => {
    fetchMessageContent();
  }, [fetchMessageContent]);

  if (!state?.data) {
    return (
      <div className="flex flex-col h-screen justify-center items-center bg-gray-100">
        <p className="text-lg text-gray-500">No data to preview</p>
        <Button className="primary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </div>
    );
  }

  return (
    <PreviewFrame
      data={state.data}
      recordId={state.recordId}
      type={state.type}
      onClose={() => navigate(-1)}
    >
      {(currentView) => (
        <LoadingInComponent isLoading={loading}>
          <div className="w-[1200px] bg-gray-100 rounded-lg shadow-md flex flex-col h-full p-[32px] no-scrollbar overflow-y-auto gap-[24px]">
            {error ? (
              <p className="text-red-500 text-center">{error}</p>
            ) : (
              <MessageBlastContent
                data={state.data}
                view={currentView}
                messageContent={messageContent}
              />
            )}
          </div>
        </LoadingInComponent>
      )}
    </PreviewFrame>
  );
};

export default MessageBlastPreview;
